export default __webpack_public_path__ + "static/media/otm-mandate-mob.37bd5cde.jpg";